// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1-_Cp","content":"GlobalSearch_content__emVOB"};